export const MAX_PAST_ORDERS = 180;
export const MIN_PAST_ORDERS = 1;
export const DEFAULT_PAST_ORDERS = 30;
export const TOTAL_ORDERS_TO_DISPLAY_TOGGLE = 0;
